const META_PIXEL_ID = "1055035666981026";

function createEventId() {
  return globalThis.crypto.randomUUID();
}

function createLeadTracker(getFbq = () => globalThis.window?.fbq) {
  const firedEventIds = new Set();

  return function trackLead(eventId) {
    if (firedEventIds.has(eventId)) return false;

    const fbq = getFbq();
    if (typeof fbq !== "function") return false;

    firedEventIds.add(eventId);
    fbq("trackSingle", META_PIXEL_ID, "Lead", {}, { eventID: eventId });
    return true;
  };
}

module.exports = {
  META_PIXEL_ID,
  createEventId,
  createLeadTracker,
};
